'use strict';

var teamsportcommon = angular.module('gymsystem.teamsportcommon', []);

teamsportcommon.factory('teamsportutil', ['$rootScope', '$filter', 'util', 'fileManager', 'server', 'live', function($rootScope, $filter, util, fileManager, server, live) {
    var teamsportutil = {};

    teamsportutil.cup = function() {
        return $rootScope.hasModule ? $rootScope.hasModule('Cup') : ($rootScope.settings && $rootScope.settings.cup);
    };

    teamsportutil.transformCompetition = function(s) {
        s.startDate = Date.newFull(s.startDate);
        s.endDate = Date.newFull(s.endDate);
        s.registrationStartDate = Date.newFull(s.registrationStartDate);
        s.registrationEndDate = Date.newFull(s.registrationEndDate);
        s.lastCancellationDate = Date.newFull(s.lastCancellationDate);
        return s;
    };

    teamsportutil.transformMatch = function(m, members) {
        if (m.referees_id) {
            if (members) {
                m.referees = m.referees_id.map(function(id) {
                    return _.findWhere(members, {id: id});
                });
            } else if ($rootScope.getMember) {
                m.referees = m.referees_id.map(function(id) {
                    return $rootScope.getMember(id);
                });
            }
        }
        if (m.activity) {
            m.activity = $rootScope.transformWorkout(m.activity);
        }
        if (m.team_activities) {
            m.team_activities.forEach(function(w) {
                if (_.isObject(w)) {
                    $rootScope.transformWorkout(w, members);
                }
            });
        }
        
        return m;
    };

    teamsportutil.transformGameClass = function(g) {
        g.competition = teamsportutil.transformCompetition(g.competition);
        if (g.teams) {
            g.teams.forEach(function(t) {
                t.created = Date.newFull(t.created);
                if (t.booker_id && $rootScope.getMember) {
                    t.booker = $rootScope.getMember(t.booker_id);
                }
            });
        }
        return g;
    };
    
    teamsportutil.intervals = [{id: 1, name: 'Every week'}, {id: 2, name: 'Every second week'}, {id: 3, name: 'Every third week'}, {id: 4, name: 'Every fourth week'}];
    teamsportutil.weekdays = [{id: 1, name: 'Monday'}, {id: 2, name: 'Tuesday'}, {id: 3, name: 'Wednesday'}, {id: 4, name: 'Thursday'}, {id: 5, name: 'Friday'}, {id: 6, name: 'Saturday'}, {id: 7, name: 'Sunday'}];
    teamsportutil.weekdays_plural = [{id: 1, name: 'Mondays'}, {id: 2, name: 'Tuesdays'}, {id: 3, name: 'Wednesdays'}, {id: 4, name: 'Thursdays'}, {id: 5, name: 'Fridays'}, {id: 6, name: 'Saturdays'}, {id: 7, name: 'Sundays'}];

    teamsportutil.getMatchTimeDisplayName = function(mt) {
        var often = '';
        var weekday = '';
        if (mt.interval > 1) {
            often = $filter('translate')({2: 'Every second', 3: 'Every third', 4: 'Every fourth'}[mt.interval]) + ' ';
            weekday = $filter('translate')(_.findWhere(teamsportutil.weekdays, {id: mt.weekday}).name).toLowerCase();
        } else {
            weekday = $filter('translate')(_.findWhere(teamsportutil.weekdays_plural, {id: mt.weekday}).name);
        }

        return often + weekday + ' ' + mt.from + ' - ' + mt.to;
    };

    teamsportutil.getMatchName = function(match) {
        if (match.name) {
            return match.name;
        }

        if (match.teams.length == 2) {
            return match.teams[0].name + ' - ' + match.teams[1].name;
        }
    };

    teamsportutil.resulttypes = [
        {id: 'number', name: 'Positive integer'},
        {id: 'integer', name: 'Integer'},
        {id: 'decimal', name: 'Decimal'},
        {id: 'pdecimal', name: 'Positive decimal'},
        {id: 'HHMMSS', name: 'Time (hours, minutes, seconds)'},
        {id: 'MMSS', name: 'Time (minutes, seconds)'},
        {id: 'SSss', name: 'Time (seconds, hundredths)'},
        {id: 'SSsss', name: 'Time (seconds, thousands)'},
        {id: 'padel', name: 'Padel'},
        {id: 'sets', name: 'Set scores'}
    ];

    // Result types reported as a single set-score string per match (e.g. '21-18, 18-21, 21-19')
    teamsportutil.isSetResult = function(type) {
        return type == 'padel' || type == 'sets';
    };

    teamsportutil.isResultValid = function(result, type) {
        if (type == 'sets') {
            return (/^\s*[0-9]+\s*-\s*[0-9]+\s*(,\s*[0-9]+\s*-\s*[0-9]+\s*)*$/.test(result));
        }
        if (type == 'number') {
            return parseInt(result) == result && parseInt(result) >= 0;
        } else if (type == 'integer') {
            return parseInt(result) == result;
        } else if (type == 'decimal') {
            return (/^(\-|\+)?([0-9]+(\.[0-9]+)?)$/.test(result));
        } else if (type == 'pdecimal') {
            return (/^([0-9]+(\.[0-9]+)?)$/.test(result));
        } else if (type == 'HHMMSS') {
            return (/^[0-9][0-9]\.[0-5][0-9].[0-5][0-9]$/.test(result));
        } else if (type == 'MMSS') {
            return (/^[0-9][0-9]\.[0-5][0-9]$/.test(result));
        } else if (type == 'SSss') {
            return (/^[0-9][0-9]\.[0-9][0-9]$/.test(result));
        } else if (type == 'SSsss') {
            return (/^[0-9][0-9]\.[0-9][0-9][0-9]$/.test(result));
        }
    };

    teamsportutil.getResultTypeHint = function(type) {
        if (type) {
            if (type == 'HHMMSS') {
                return 'HH.MM.SS';
            } else if (type == 'MMSS') {
                return 'MM.SS';
            } else if (type == 'SSss') {
                return 'SS.ss';
            } else if (type == 'SSsss') {
                return 'SS.sss';
            } else if (type == 'sets') {
                return '21-18, 18-21, 21-19';
            }
        }
    };

    function fetchInvalidResultTypes() {
         var fetch = function() {
            server.get('/api/teamsport/resultinvalid/get').then(function(result) {
                teamsportutil.resultinvalid = result;
            });
        };

        live.subscribe({ type: 'teamsportresultinvalidtype', callback: fetch });
        fetch();
    }
    if (!$rootScope.hasModule || $rootScope.hasModule('TeamSports')) {
        fetchInvalidResultTypes();
    }

    teamsportutil.formatResult = function(result_object) {
        if (result_object) {
            if (result_object.invalid_id || result_object.invalid) {
                if (teamsportutil.resultinvalid) {
                    var i = _.findWhere(teamsportutil.resultinvalid, {id: result_object.invalid_id || result_object.invalid.id});
                    return i ? i.name : '';
                }
                return '';
            } else {
                return result_object.result;
            }
        }
    };

    teamsportutil.tablecolumntypes = [
        {id: 'position', name: 'TPosition'},
        {id: 'image', name: 'Team image'},
        {id: 'imagename', name: 'Team image and name', sortable: true},
        {id: 'name', name: 'Team name', sortable: true},
        {id: 'namemembers', name: 'Team name and members', sortable: true},
        {id: 'playedmatches', name: 'Number of played matches', sortable: true},
        {id: 'matchesleft', name: 'Number of matches left', sortable: true},
        {id: 'won', name: 'Number of won matches', sortable: true, descending: true},
        {id: 'lost', name: 'Number of lost matches', sortable: true},
        {id: 'points', name: 'Points', sortable: true, descending: true},
        {id: 'ties', name: 'Number of ties', sortable: true, descending: true},
        {id: 'resultsum', name: 'Sum of result', sortable: true, descending: true},
        {id: 'opponentresultsum', name: 'Sum of opponent result', sortable: true},
        {id: 'resultdiff', name: 'Result difference', sortable: true, descending: true},
        {id: 'matches', name: 'Matches'},
        {id: 'question', name: 'Registration question', sortable: true},
        {id: 'match', name: 'Match', sortable: true},
        {id: 'headtohead', name: 'Head to head matches', sortable: true, descending: true},
        {id: 'setdifference', name: 'Set difference', sortable: true, descending: true},
        {id: 'gamedifference', name: 'Game difference', sortable: true, descending: true},
        {id: 'pointssum', name: 'Won points', sortable: true, descending: true},
        {id: 'opponentpointssum', name: 'Lost points', sortable: true},
        {id: 'pointsdiff', name: 'Point difference', sortable: true, descending: true}
    ];

    teamsportutil.defaultcolors = {
        text: '#767676',
        background: '#fff'
    };

    teamsportutil.tablelinetype = [
        {id: 'none', name: 'None'},
        {id: 'thin', name: 'Thin', css: '2px solid'},
        {id: 'dashed', name: 'Dashed', css: '2px dashed'},
        {id: 'thick', name: 'Thick', css: '4px solid'}
    ];

    teamsportutil.buildTable = function(data) {
        var showColumn = function(c) {
            return c.mobile || !util.isSmallScreen();
        };

        var getColumn = function(c, index) {
            var src;
            var size;
            var text;
            if (c.format == 'image') {
                src = function(i) {
                    var value = c.text ? i[index][0] : i[index];
                    return $rootScope.image(c.imagetype, value, c.imagesize);
                };
                size = function() { return c.imagesize + 'px'; };
                if (c.text) {
                    text = function(i) {
                        return i[index][1];
                    };
                }
            }
            var style = {};
            if (c.bold) {
                style['font-weight'] = 'bold';
            }
            if (c.text_color) {
                style.color = c.text_color;
            }
            if (c.background_color) {
                style['background-color'] = c.background_color;
            }
            var visible = function() {
                return showColumn(c);
            };

            return {field: String(index), title: util.isSmallScreen() ? c.shortname : c.name, format: c.format, src: src, size: size, text: text, style: style, visible: visible, showHtml: true };
        };

        var style = {};
        if (data.text_color) {
            style.color = data.text_color;
        }
        if (data.background_color) {
            style['background-color'] = data.background_color;
        }

        var getRowStyle;
        if (data.lines) {
            getRowStyle = function(rownr) {
                var line;
                data.lines.filter(function(d) { return !d.from_bottom;}).forEach(function(d) {
                    if (rownr > d.position) {
                        line = d;
                    }
                });
                data.lines.filter(function(d) { return d.from_bottom;}).forEach(function(d) {
                    if (rownr > data.rows.length - d.position) {
                        line = d;
                    }
                });

                if (line) {
                    var res = {};

                    if ( (!line.from_bottom && rownr == line.position + 1) || (line.from_bottom && rownr == data.rows.length - line.position + 1)) {
                        var lt = _.findWhere(teamsportutil.tablelinetype, {id: line.type});
                        var css = lt && lt.css;
                        if (css) {
                            res['border-top'] = css;
                        }
                    }
                    if (line.text_color) {
                        res.color = line.text_color;
                    }
                    if (line.background_color) {
                        res['background-color'] = line.background_color;
                    }
                    return res;
                }
            };
        }

        var config = {
            getItems: function() {
                return data.rows;
            },
            hideSearch: true,
            striped: false,
            bordered: true,
            correctionWidth: true,
            columns: data.columns.map(getColumn),
            tableLimit: data.tableLimit || 1000,
            style: style,
            showHeader: data.header,
            showSum: data.show_totals === false ? false : undefined,
            getRowStyle: getRowStyle
        };

        return config;
    };

    teamsportutil.getImage = function(team, size) {
        var obj;
        var type = 'team';
        size = size || 50;
        if (team.group || team.group_id) {
            obj = team.group || team.group_id;
            type = 'usergroup';
        } else {
            obj = team.user || team.user_id;
            type = 'member';
        }

        if (obj) {
            if (_.isObject(obj)) {
                return fileManager.fileLinkByObject(obj, size, type);
            } else {
                if (type == 'member') {
                    return '/api/memberapi/image/member/get?size=' + size + 'x' + size + '&id=' + (obj.id || obj);
                }
                return '/api/public/image/get?size=' + size + 'x' + size + '&type=' + type + '&id=' + (obj.id || obj);
            }
        } else {
            if (team.id) {
                return '/api/public/image/get?size=' + size + 'x' + size + '&type=team&id=' + team.id;
            } else {
                return $rootScope.getEmptyImage();
            }
        }
    };

    teamsportutil.getCurrentMember = function() {
        return $rootScope.isStaffApp ? $rootScope.currentStaff : $rootScope.member;
    };

    teamsportutil.canReportResult = function(match) {
        var member = teamsportutil.getCurrentMember();
        if (!member) {
            return false;
        }
        if ($rootScope.hasPermission('Competition handling')) {
            return true;
        }

        if (!teamsportutil.settings) {
            return false;
        }

        var is_referee = (match.referees_id && match.referees_id.indexOf(member.id) != -1);
        var is_team_leader = !!_.find(match.teams, function(team) { return (team.group && team.group.responsible.indexOf(member.id) != -1); });
        var time_ok = match.activity && (new Date() < match.activity.endTime.clone().addDays(teamsportutil.settings.result_report_days));
        var referee_can_report = ['both', 'result'].indexOf(teamsportutil.settings.referee_report) != -1;
        var team_leader_can_report = ['both', 'both_team', 'result'].indexOf(teamsportutil.settings.teamleader_report) != -1;
        return ( (is_referee && referee_can_report) || (is_team_leader && team_leader_can_report) ) && (!match.finished || time_ok);
    };

    teamsportutil.canReportEvent = function(match, for_team) {
        var member = teamsportutil.getCurrentMember();
        if (!member) {
            return false;
        }
        if ($rootScope.hasPermission('Competition handling')) {
            return true;
        }

        if (!teamsportutil.settings) {
            return false;
        }

        var is_referee = (match.referees_id && match.referees_id.indexOf(member.id) != -1);
        var is_team_leader = !!_.find(match.teams, function(team) { return (team.group && team.group.responsible.indexOf(member.id) != -1); });
        var is_team_leader_for_team = !for_team || (for_team.group && for_team.group.responsible.indexOf(member.id) != -1);

        var time_ok = match.activity && new Date() < match.activity.endTime.clone().addDays(teamsportutil.settings.event_report_days);
        var referee_can_report = ['both', 'event'].indexOf(teamsportutil.settings.referee_report) != -1;
        var team_leader_can_report_for_all = ['both', 'event'].indexOf(teamsportutil.settings.teamleader_report) != -1;
        var team_leader_can_report_for_own = ['both_team', 'event_team'].indexOf(teamsportutil.settings.teamleader_report) != -1;
        var team_leader_can_report = team_leader_can_report_for_all || (team_leader_can_report_for_own && is_team_leader_for_team);

        return ( (is_referee && referee_can_report) || (is_team_leader && team_leader_can_report) ) && (!match.finished || time_ok);
    };

    teamsportutil.canLiveReport = function() {
        return teamsportutil.settings.live_report;
    };

    teamsportutil.getSubstituteTypes = function() {
        return teamsportutil.settings.substitute_type;
    };

    function fetchSettings() {
         var fetch = function() {
            server.get('/api/teamsport/settings/get').then(function(settings) {
                teamsportutil.settings = settings;
            });
        };

        live.subscribe({ type: 'settings:teamsportsettings', callback: fetch });
        fetch();
    }
    fetchSettings();

    return teamsportutil;
}]);

teamsportcommon.controller('TeamMatchSetResultCtrl', ['$scope', '$controller', '$filter', 'confirm', 'match', 'teamsportutil', 'server', 'live', function($scope, $controller, $filter, confirm, match, teamsportutil, server, live) {
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.titleSuffix = function() {
        return $filter('translate')('Result').toLowerCase() + ' ' + $filter('translate')('for') + ' ' + teamsportutil.getMatchName(match);
    };

    function fetchInvalidTypes() {
        return server.get('/api/teamsport/resultinvalid/get').then(function(res) {
            $scope.invalidtypes = res;
            $scope.invalidtypes.unshift({id: 0, name: 'Valid result'});
        });
    }

    $scope.item = match;

    $scope.postUrl = '/api/teamsport/match/setresult';

    $scope.callCloseOnSuccess = true;

    var type = (!match.result_type || match.result_type == 'number' || match.result_type == 'integer') ? 'number' : 'infoText';
    var multiAttempt = match.number_of_attempts > 1;

    // Cup results can't be cleared (bracket advancement has no undo); league ones can.
    var isCup = match.is_cup === true;

    // True when saving now would return the match to "unplayed".
    function isClearing() {
        var f = _.findWhere($scope.fields, {name: 'finished'});
        return !isCup && !!f && !f.value;
    }

    // null = lookup not finished (warn on clear until we know, don't silently skip).
    $scope.hasEvents = null;
    function fetchEvents() {
        server.get('/api/teamsport/event/get', {match_id: match.id}).then(function(data) {
            $scope.hasEvents = !!(data && data.length);
        }, function() { $scope.hasEvents = null; });
    }
    fetchEvents();
    // Keep it fresh if another user reports events on this match while the dialog is open.
    live.subscribe({
        type: 'teamsportevent',
        scope: $scope,
        callback: function(event) {
            if (event.match_id == match.id) {
                fetchEvents();
            }
        }
    });

    function getResultFields() {
        return $scope.fields.filter(function(f) {
            return f.type == 'number' || f.type == 'infoText';
        });
    }

    function getInvalidFields() {
        return $scope.fields.filter(function(f) {
            return f.type == 'select';
        });
    }

    $scope.getSubmitItem = function() {
        var finished = _.findWhere($scope.fields, {name: 'finished'}).value;
        var item = {match_id: match.id, finished: finished };
        // Unfinishing a league match clears the result, ignoring any leftover scores.
        var clearing = !isCup && !finished;
        if(teamsportutil.isSetResult(match.result_type)) {
            if (clearing) {
                item.result = null;
            } else {
                var rt = _.findWhere($scope.fields, {name: 'setResultType'});
                var invalid_id = (rt && rt.value && rt.value.id) ? rt.value.id : null;
                if (invalid_id) {
                    var w = _.findWhere($scope.fields, {name: 'setWinner'});
                    item.invalid_id = invalid_id;
                    item.winner_team_id = w && w.value ? w.value.id : null;
                    item.result = null;
                } else {
                    item.result = $scope.fields.find(f => f.name == 'result')?.value;
                }
            }
        } else if (multiAttempt) {
            var invalidfields = getInvalidFields();

            item.result = match.teams.map(function(team) {
                if (clearing) {
                    return { team_id: team.id, invalid_id: null, attempts: [] };
                }
                var i = _.findWhere(invalidfields, {team_id: team.id});
                var invalid_id = i.value.id == 0 ? null : i.value.id;
                var attempts = getResultFields()
                    .filter(function(f) { return f.team_id == team.id; })
                    .map(function(f) { return f.value == null ? '' : String(f.value); });
                return {
                    team_id: team.id,
                    invalid_id: invalid_id,
                    attempts: invalid_id ? [] : attempts
                };
            });
        } else {
            var invalidfields = getInvalidFields();

            item.result = getResultFields().map(function(row) {
                if (clearing) {
                    return { team_id: row.team_id, result: null, invalid_id: null };
                }
                var i = _.findWhere(invalidfields, {team_id: row.team_id});
                return {
                    team_id: row.team_id,
                    result: i.value.id == 0 ? row.value : null,
                    invalid_id: i.value.id == 0 ? null : i.value.id
                };
            });
        }
        return item;
    };

    // Warn before clearing a result that still has reported events, then save.
    $scope.submit = function() {
        if (isClearing() && $scope.hasEvents !== false) {
            confirm.show('This match has reported events (goals etc.). Clearing the result will also remove them. Do you want to continue?').then(function() {
                $scope.doSubmit($scope.getSubmitItem());
            });
            return;
        }
        $scope.doSubmit($scope.getSubmitItem());
    };

    $scope.canSubmit = function() {
        if (isClearing()) {
            // Returning to unplayed — empty results allowed.
            return true;
        }
        return _.every(getResultFields(), function(field) {
            if (!field.visible(field) || field.type != 'infoText') {
                return true;
            }
            if (field.attempt_index != null) {
                // Attempts are optional, may be a foul ("X"), and may use a Swedish decimal comma
                if (field.value == null || field.value === '') {
                    return true;
                }
                var v = String(field.value).trim();
                if (/^[xX]$/.test(v)) {
                    return true;
                }
                return teamsportutil.isResultValid(v.replace(',', '.'), match.result_type);
            }
            return teamsportutil.isResultValid(field.value, match.result_type);
        });
    };

    function setRequired() {
        if (multiAttempt) {
            // Attempts are individually optional, so nothing becomes required when finishing
            return;
        }
        var finishedField = _.findWhere($scope.fields, {name: 'finished'});
        if (!finishedField) {
            return;
        }
        $scope.fields.forEach(function(f, i) {
            if (i % 2 != 0) {
                // Cup results always required; league results only while finished.
                f.required = isCup || finishedField.value;
            }
        });
    }

    // Fallback for callers that passed a match without is_cup.
    if (match.is_cup === undefined) {
        server.get('/api/teamsport/match/get', {id: match.id}).then(function(res) {
            var full = _.isArray(res) ? res[0] : res;
            if (full && full.is_cup !== undefined) {
                isCup = full.is_cup === true;
                setRequired();
            }
        }, function() {});
    }

    $scope.fields = [];
    if(teamsportutil.isSetResult(match.result_type)) {
        fetchInvalidTypes().then(function() {
            var oldresult = match.result && match.result[0];
            var setResultType = {name: 'setResultType', title: 'Result type', type: 'select', required: true, options: function() { return $scope.invalidtypes; }, useId: true};
            setResultType.value = _.findWhere($scope.invalidtypes, {id: (oldresult && oldresult.invalid_id) ? oldresult.invalid_id : 0});
            var isValid = function() { return setResultType.value && setResultType.value.id == 0; };
            var isInvalid = function() { return setResultType.value && setResultType.value.id != 0; };
            $scope.fields.push(setResultType);
            $scope.fields.push({name: 'result', title: 'Result', type: 'text', value: (oldresult && !oldresult.invalid_id) ? oldresult.result : '', visible: isValid});
            $scope.fields.push({hint: match.result_type == 'padel' ? '6-4, 4-6, 1-6' : '21-18, 18-21, 21-19', hintClass: 'alert-info', title: 'Example', visible: isValid});
            var winner = {name: 'setWinner', title: 'Winner', type: 'select', required: true, options: function() { return match.teams; }, useId: true, getName: function(t) { return t.name; }, visible: isInvalid};
            winner.value = (oldresult && oldresult.invalid_id) ? _.findWhere(match.teams, {id: oldresult.team_id}) : null;
            $scope.fields.push(winner);
            $scope.fields.push({name: 'finished', title: 'Match is finished', type: 'checkbox', value: true, change: setRequired});
        });
    } else {
        fetchInvalidTypes().then(function() {
            match.teams.forEach(function(team, index) {
                var oldresult = _.findWhere(match.result, {team_id: team.id});
                var invalidtype = {name: '' + index, getTitle: function() { return team.name; }, type: 'select', required: true, team_id: team.id, options: function() { return $scope.invalidtypes; }, useId: true, changed: function(field) { var id = field.value.id || null;  return !oldresult || oldresult.invalid_id != id; } };
                invalidtype.value = _.findWhere(invalidtype.options(), {id: (oldresult && oldresult.invalid_id) ? oldresult.invalid_id : 0});
                $scope.fields.push(invalidtype);
                var hasValidResult = function(field) {
                    var f = _.findWhere(getInvalidFields(), {team_id: field.team_id});
                    return f && f.value && f.value.id == 0;
                };
                if (multiAttempt) {
                    for (var ai = 0; ai < match.number_of_attempts; ai++) {
                        (function(ai) {
                            var oldattempt = oldresult && oldresult.attempts ? oldresult.attempts[ai] : undefined;
                            var af = {name: index + '_' + ai, getTitle: function() { return $filter('translate')('Attempt') + ' ' + (ai + 1); }, type: type, required: false, nullIsValue: true, team_id: team.id, attempt_index: ai, changed: function(field) { return !oldresult || oldattempt != field.value; }, visible: hasValidResult };
                            if (type == 'infoText') {
                                af.info = match.unit || teamsportutil.getResultTypeHint(match.result_type);
                            }
                            af.value = oldattempt;
                            if (match.result_type == 'integer') {
                                af.min = -1000000;
                            }
                            if (type == 'number' && af.value != null) {
                                af.value = Number(af.value);
                            }
                            $scope.fields.push(af);
                        })(ai);
                    }
                } else {
                    var res = {name: '' + index, title: '', type: type, required: true, nullIsValue: true, team_id: team.id, changed: function(field) { return !oldresult || oldresult.result != field.value; }, visible: hasValidResult };
                    if (type == 'infoText') {
                        res.info = match.unit || teamsportutil.getResultTypeHint(match.result_type);
                    }
                    res.value = oldresult ? oldresult.result : undefined;
                    if (!res.value && type == 'number') {
                        res.value = 0;
                    }
                    if (match.result_type == 'integer') {
                        res.min = -1000000;
                    }
                    if (type == 'number') {
                        res.value = Number(res.value);
                    }
                    $scope.fields.push(res);
                }
            });

            if (multiAttempt) {
                $scope.fields.push({
                    hint: 'Leave an attempt blank if not taken, or enter X for a foul.',
                    hintClass: 'alert-info'
                });
            }

            $scope.fields.push(
                {name: 'finished', title: 'Match is finished', type: 'checkbox', value: true, change: setRequired}
            );
        });
    }
}]);

teamsportcommon.controller('TeamMatchAddEventsCtrl', ['$rootScope', '$scope', '$controller', 'server', 'teamsportutil', '$q', 'match', function($rootScope, $scope, $controller, server, teamsportutil, $q, match) {
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.match = match;
    $scope.loadingStatus = {};

    function fetchEvents() {
        server.get('/api/teamsport/event/get', {match_id: match.id}).then(function(data) {
            $scope.events = data;
        });
    }

    function getDisplayName(b) {
        let a = match.shirt_numbers?.find(shirt => shirt.team == b.team_id && shirt.user == b.user.id);
        let shirt = a && a.shirt;
        if (!shirt) {
            let team = match.teams.find(team => team.id == b.team_id); 
            let shirtUser = team.group?.shirt_numbers?.find(user => user.user_id == b.user.id);
            shirt = shirtUser && shirtUser.shirt;
        }        
        return (shirt ? shirt + ' ' : '') + b.user.name;
    }

    function updateResultSum() {
        $scope.resultsum = [];
        $scope.configs.forEach(function(config) {
            var sum = 0;
            config.columns.filter(function(c) { return c.field.startsWith('et_'); }).forEach(function(c) {
                var etid = Number(c.field.substring(3));
                var et = _.findWhere($scope.eventtypes, {id: etid});
                if (et.points) {
                    var num = 0;
                    config.getItems().forEach(function(i) {
                        if (i[c.field] && !isNaN(i[c.field])) {
                            num += Number(i[c.field]);
                        }
                    });
                    sum += num * et.points;
                }
            });
            $scope.resultsum.push(sum);
        });
    }

    function createConfigs() {
        $scope.configs = match.team_activities.map(function(activity, index) {
            let team = match.teams[index];
            let team_id = team.id;
            var items = activity ? activity.bookings.map(function(b) {
                var item = {id: b.id, user: b.user, team_id: team_id };
                var evs = $scope.events.filter(function(e) { return e.user_id == b.user.id && e.team_id == team_id; });
                if (evs.length) {
                    $scope.eventtypes.forEach(function(et) {
                        var num = evs.filter(function(e) { return e.eventtype_id == et.id; }).length;
                        if (num) {
                            item['et_' + et.id] = num;
                        }
                    });
                }
                return item;
            }) : [{id: team.user_id, user: $rootScope.getMember(team.user_id), team_id: team_id}];
            var config = {
                getItems: function() {
                    return items;
                },
                orderColumn: 'user.name',
                columns: [
                    {field: 'image', title: '', src: function(b) { return $rootScope.image('Member', b.user); } },
                    {field: 'user.name', title: 'Name', getValue: getDisplayName }
                ],
                hideSearch: true
            };

            $scope.eventtypes.forEach(function(et) {
                var c = {field: 'et_' + et.id, title: et.name, format: 'editable', change: updateResultSum };
                config.columns.push(c);
            });

            return config;
        });

        updateResultSum();
    }

    function fetchEventTypes() {
        server.get('/api/teamsport/eventtype/get').then(function(data) {
            $scope.eventtypes = match.division.competitionstep.gameclass.competition.teamsport.eventtypes.map(function(id) {
                return _.findWhere(data, {id: id});
            });
        });
    }

    fetchEvents();
    fetchEventTypes();

    var u = $scope.$watch(function() {
        return $scope.eventtypes !== undefined && $scope.events !== undefined && teamsportutil.settings !== undefined;
    }, function() {
        if ($scope.eventtypes && $scope.events) {
            createConfigs();
            u();
        }
    });

    $scope.canAddEventsFor = function(team) {
        return teamsportutil.canReportEvent(match, team);
    };

    $scope.valuesChanged = function() {
        var changed = false;
        ($scope.configs || []).forEach(function(config) {
            config.getItems().forEach(function(item) {
                var evs = $scope.events.filter(function(e) { return e.user_id == item.user.id && e.team_id == item.team_id; });
                $scope.eventtypes.forEach(function(et) {
                    var evt = evs.filter(function(e) { return e.eventtype_id == et.id; });
                    var count_in_events = evt.length;
                    var new_count = Number(item['et_' + et.id]);
                    if (new_count - count_in_events > 0) {
                        changed = true;
                    } else if (new_count - count_in_events < 0) {
                        changed = true;
                    }
                });
            });
        });

        return changed;
    };

    $scope.canSubmit = function() {
        if (!match.finished) {
            return true;
        }

        var ok = true;
        match.teams.forEach(function(team, index) {
            var res = _.findWhere(match.result, {team_id: team.id});
            if (res && !res.invalid_id && !isNaN(res.result)) {
                var stored_result = Number(res.result);
                if ($scope.resultsum[index] > stored_result) {
                    ok = false;
                }
            }
        });

        $scope.resultsumerror = !ok;
        return ok;
    };

    $scope.submit = function() {
        // For each user
        // For each item type
        // Add x events or remove y events

        var wait = [];
        $scope.loadingStatus.loading = true;

        $scope.configs.forEach(function(config) {
            config.getItems().forEach(function(item) {
                var evs = $scope.events.filter(function(e) { return e.user_id == item.user.id && e.team_id == item.team_id; });
                $scope.eventtypes.forEach(function(et) {
                    var evt = evs.filter(function(e) { return e.eventtype_id == et.id; });
                    var count_in_events = evt.length;
                    var new_count = Number(item['et_' + et.id]);
                    if (new_count - count_in_events > 0) {
                        var toadd = new_count - count_in_events;
                        if (toadd < 100) {
                            wait.push(server.post('/api/teamsport/event/add', {count: toadd, match_id: match.id, eventtype_id: et.id, team_id: item.team_id, user_id: item.user.id}));
                        }
                    } else if (new_count - count_in_events < 0) {
                        var toremove = count_in_events - new_count;
                        var rlist = [];
                        for (var i=0; i < toremove; ++i) {
                            rlist.push(evt[evt.length-1-i].id);
                        }
                        wait.push(server.post('/api/teamsport/event/remove', null, {id: rlist.join(',') }));
                    }
                });
            });
        });

        $q.all(wait).then(function() {
            $scope.$close();
        });
    };
}]);

teamsportcommon.controller('TeamCaptainCtrl', ['$scope', '$controller', 'match', 'bookings','team', function($scope, $controller, match, bookings, team) {
    $controller('ChangeCtrl', {$scope: $scope});

    $scope.title = 'SELECT_TEAM_CAPTAIN_STAFF';
    $scope.submitTitle = 'SELECT_TEAM_CAPTAIN_STAFF';

    $scope.team_captain = match.team_captains[team.id];

    const captainOptions = bookings.map(b => {return {id: b.user.id, name: b.user.name}});

    $scope.fields = [{ name: 'captainId', title: 'Team captain', options: captainOptions, type: 'radiobutton', value: $scope.team_captain, useId: true }];

    $scope.postUrl = '/api/teamsport/match/team/captain/set';

    $scope.getSubmitItem = () => {
        return { matchId: match.id, teamId: team.id, captainId: $scope.fields[0].value };
    }

    $scope.valuesChanged = () => {
        return $scope.fields[0].value != $scope.team_captain;
    }

    $scope.afterSubmit = () => {
        $scope.team_captain = $scope.fields[0].value;
        $scope.loadingStatus.loading = false;
    };
}]);

teamsportcommon.controller('SetShirtNumbersCtrl', ['$scope', '$controller', '$filter', 'server', 'match', 'bookings', 'team', function($scope, $controller, $filter, server, match, bookings, team) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.postUrl = '/api/teamsport/match/set_shirt_numbers';
    $scope.title = 'Set shirt numbers';
    $scope.callCloseOnSuccess = true;
    $scope.successTitle = 'Saved changes';
    $scope.failedTitle = 'Failed to save changes';

    bookings = $filter('orderBy')(bookings, 'user.name');

    server.get('/api/teamsport/get_shirt_numbers_from_group', {group_id: team.group.id, match_id: match.id}).then(function(shirts) {
        $scope.fields = bookings.map(function(b) {
            var a = _.findWhere(match.shirt_numbers, {team: team.id, user: b.user.id});
            var gs = _.findWhere(shirts, {user_id: b.user.id});
            var sn = (a && a.shirt) || (gs && gs.shirt);
            return { name: b.user.id, title: b.user.name, type: 'number', user: b.user, value: +sn };
        });
    });

    $scope.getSubmitItem = function() {
        var item = { match_id: match.id, team_id: team.id };
        item.shirts = $scope.fields.filter(function(f) { return f.value; }).map(function(f) {
            return {user_id: f.user.id, shirt: f.value};
        });
        return item;
    };
}]);

teamsportcommon.directive('teamsportmatch', ['$rootScope', '$routeParams', 'server', 'live', 'util', 'teamsportutil', '$filter', 'workoutProvider', '$modal', '$modalStack', 'formatter', function($rootScope, $routeParams, server, live, util, teamsportutil, $filter, workoutProvider, $modal, $modalStack, formatter) {
    return {
        restrict: 'E',
        templateUrl: 'views/teamsportmatchcomponent.html',
        scope: {
            config: '='
        },
        link: function($scope) {
            $scope.hasPermission = $rootScope.hasPermission;
            $scope.image = $rootScope.image;
            $scope.teamImage = teamsportutil.getImage;
            $scope.formatResult = teamsportutil.formatResult;
            $scope.getMember = $rootScope.getMember || function(id) {
                return _.findWhere($scope.members, {id: id});
            };
            $scope.isStaffApp = $rootScope.isStaffApp;

            $scope.showFormationOrContacts = function() {
                return $scope.match && !$scope.match.division.competitionstep.gameclass.individual && ($scope.isStaffApp || $rootScope.member) && !_.any($scope.match.team_activities, function(a) { return !a; });
            };

            $scope.showTable = function() {
                return $scope.match && $scope.match.division.competitionstep.gameclass.one_match;
            };

            // Show the backend result table inline (not in a tab) for individual competitions that have one configured
            $scope.useResultTable = function() {
                if (!$scope.match || $scope.match.division.competitionstep.gameclass.one_match) {
                    return false;
                }
                var gameclass = $scope.match.division.competitionstep.gameclass;
                return !!(gameclass.individual && $scope.matchtableconfig && $scope.matchtableconfig.columns && $scope.matchtableconfig.columns.length);
            };

            function is_numeric(type) {
                return !!{'number': 1, 'integer': 1, 'decimal': 1, 'pdecimal': 1}[type];
            }

            $scope.showAsFight = function() {
                return $scope.match && (is_numeric($scope.match.result_type) || teamsportutil.isSetResult($scope.match.result_type)) && $scope.match.teams.length == 2;
            };

            $scope.isSetResult = function() {
                return $scope.match && teamsportutil.isSetResult($scope.match.result_type);
            };

            // Winning team's name for a walk over / DNF set match (winner stored on the result row)
            $scope.setWinnerName = function() {
                var r0 = $scope.match && $scope.match.result && $scope.match.result[0];
                if (r0 && r0.invalid_id && r0.team_id) {
                    var t = _.findWhere($scope.match.teams, {id: r0.team_id});
                    return t ? t.name : '';
                }
                return '';
            };

            // Sets won by the team at the given order (0 = left/home, 1 = right/away) from the set-score string
            $scope.getSetsWon = function(teamIndex) {
                if (!$scope.match || !$scope.match.result || !$scope.match.result[0]) {
                    return 0;
                }
                var won = 0;
                ($scope.match.result[0].result || '').split(',').forEach(function(s) {
                    var p = s.split('-').map(function(x) { return parseInt(x.trim(), 10); });
                    if (p.length == 2 && !isNaN(p[0]) && !isNaN(p[1])) {
                        if (teamIndex == 0 && p[0] > p[1]) { won++; }
                        else if (teamIndex == 1 && p[1] > p[0]) { won++; }
                    }
                });
                return won;
            };

            $scope.getResult = function(team) {
                var res = _.findWhere($scope.match.result, {team_id: team.id});
                if (res) {
                    return teamsportutil.formatResult(res);
                } else if (is_numeric($scope.match.result_type)) {
                    return '0';
                }
            };

            $scope.showQuestion = function(q) {
                return q.show_on_match;
            };

            var match_id;

            function fetchMembers() {
                server.get('/api/memberapi/teamsport/get_member_in_match', {match_id: $scope.config.match_id}).then(function(data) {
                    data.forEach($rootScope.transformMember);
                    $scope.members = data;
                });
            }
            if (!$scope.isStaffApp) {
                fetchMembers();
            }

            function fetchTable() {
                var gameclass = $scope.match && $scope.match.division.competitionstep.gameclass;
                if (gameclass && (gameclass.one_match || gameclass.individual)) {
                    server.get('/api/memberapi/teamsport/result/for_division', {division_id: $scope.match.division_id, finished: false}).then(function(data) {
                        $scope.matchtableconfig = teamsportutil.buildTable(data);
                    });
                }
            }

            function fetchMatch() {
                server.get('/api/teamsport/match/get', {id: match_id, full: true}).then(function(data) {
                    var afterWait = function() {
                        if (!$scope.match) {
                            $scope.resultTabActive = true;
                        }
                        $scope.match = teamsportutil.transformMatch(data, $scope.isStaffApp ? null : $scope.members);
                        $scope.contacts = null;
                        var minus = $scope.match.highest_is_best ? '-' : '';
                        $scope.buildMultiResultConfig();
                        $scope.multiResultConfig.orderColumn = minus + 'result';
                        fetchTable();
                    };

                    if ($scope.isStaffApp) {
                        $rootScope.waitFor(['staffs', 'workouttypes', 'members', 'sites']).then(afterWait);
                    } else {
                        util.waitFor($scope, 'members').then(afterWait);
                    }
                }); 
            }

            $scope.$watch('config.match_id', function(value) {
                if (!match_id && value) {
                    match_id = value;
                    fetchMatch();
                }
            });

            function fetchEventTypes() {
                server.get('/api/teamsport/eventtype/get').then(function(data) {
                    $scope.eventtypes = data;
                });
            }
            fetchEventTypes();

            function sortEvents(events) {
                return Array.mergeSort(events, function(a, b) {
                    if (a.matchtime && b.matchtime) {
                        return a.matchtime < b.matchtime ? 1 : (a.matchtime > b.matchtime ? -1 : 0);
                    }

                    return a.created < b.created ? 1 : (a.created > b.created ? -1 : 0);
                });
            }

            function fetchEvents() {
                server.get('/api/teamsport/event/get', {match_id: match_id}).then(function(data) {
                    var afterWait = function() {
                        data.forEach(function(e) {
                            e.created = Date.newFull(e.created);
                            e.eventtype = _.findWhere($scope.eventtypes, {id: e.eventtype_id});
                            e.user = $scope.getMember(e.user_id);
                        });
                        $scope.events = data;
                        util.waitFor($scope, 'match').then(function() {
                            $scope.periods = $scope.match.division.competitionstep.gameclass.competition.teamsport.timeperiods ? $scope.match.division.competitionstep.gameclass.competition.teamsport.timeperiods.split(',').map(function(x) { return {name: x, id: x}; }) : [];
                            $scope.periods.forEach(function(p) {
                                p.events = sortEvents($scope.events.filter(function(e) { return e.timeperiod == p.id; }));
                            });

                            if ($scope.periods.length == 0) {
                                $scope.periods.push( {id: 'Events', name: $filter('translate')('EVENTS_TEXT'), events: [] });
                            }
                            var noperiod = sortEvents($scope.events.filter(function(e) { return !e.timeperiod; }));
                            noperiod.forEach(function(e) {
                                $scope.periods[0].events.push(e);
                            });
                            $scope.periods.reverse();
                        });
                    };

                    util.waitFor($scope.isStaffApp ? $rootScope : $scope, 'members').then(afterWait);
                });
            }

            $scope.$watch('eventtypes', function() {
                if ($scope.eventtypes) {
                    fetchEvents();
                }
            });

            $scope.showActivity = function(id) {
                workoutProvider.getWorkoutById(id).then(function(w) {
                    $rootScope.showWorkout(w);
                });
            };

            $scope.showMatch = function(match) {
                if ($rootScope.showMatch) {
                    $rootScope.showMatch(match);
                }
            };

            $scope.addEvent = function() {
                $modal.open({
                    templateUrl: 'views/addmodal.html',
                    controller: 'TeamSportEventAddCtrl',
                    resolve: {
                        match: function() {
                            return $scope.match;
                        }
                    }
                });
            };

            $scope.changeEvent = function(teamsportevent) {
                if ($scope.canReportEvent()) {
                    $modal.open({
                        templateUrl: 'views/teamsporteventchange.html',
                        controller: 'TeamSportEventChangeCtrl',
                        resolve: {
                            match: function() {
                                return $scope.match;
                            },
                            teamsportevent: function() {
                                return teamsportevent;
                            }
                        }
                    });
                }
            };

            $scope.getMatchStatus = function() {
                if ($scope.match && $scope.match.finished) {
                    return 'MATCH_STATUS_END';
                }
            };

            $scope.setResult = function() {
                $modal.open({
                    templateUrl: 'views/changemodal.html',
                    controller: 'TeamMatchSetResultCtrl',
                    resolve: {
                        match: function() {
                            return $scope.match;
                        }
                    }
                });
            };

            $scope.registerMatchEvents = function() {
                $modal.open({
                    templateUrl: 'views/matchevents.html',
                    controller: 'TeamMatchAddEventsCtrl',
                    windowClass: 'huge-modal-window',
                    resolve: {
                        match: function() {
                            return $scope.match;
                        }
                    }
                });
            };

            $scope.getContacts = function() {
                if (!$scope.match) {
                    return;
                }

                if ($scope.contacts) {
                    return $scope.contacts;
                }

                var contacts = [];

                if ($scope.match.referees) {
                    $scope.match.referees.forEach(function(referee) {
                        contacts.push({name: 'Referee', user: referee});
                    });
                }

                $scope.match.teams.forEach(function(team) {
                    if (team.group) {
                        (team.group.responsible || []).forEach(function(user_id) {
                            contacts.push({name: $filter('translate')('Team leader') + ' ' + team.name, user: $scope.getMember(user_id) });
                        });
                    }
                });

                $scope.contacts = contacts;
                return contacts;
            };

            $scope.getRoom = function() {
                if (!$scope.match || !$scope.match.activity) {
                    return;
                }
                return _.findWhere($scope.match.activity.resources, {resourceType: 'room'});
            };

            $scope.getLocation = function() {
                if (!$scope.match || !$scope.match.activity) {
                    return;
                }
                return _.findWhere($scope.match.activity.resources, {resourceType: 'location'});
            };

            $scope.changeMatch = function() {
                $modal.open({
                    templateUrl: 'views/changemodal.html',
                    controller: 'TeamMatchChangeCtrl',
                    resolve: {
                        match: function() {
                            return $scope.match;
                        }
                    }
                });
            };

            $scope.changeTeam = function(team) {
                if ($scope.isStaffApp && $rootScope.hasPermission('Competition handling')) {
                    $modal.open({
                        templateUrl: 'views/changemodal.html',
                        controller: 'TeamChangeCtrl',
                        resolve: {
                            team: function() {
                                return team;
                            },
                            division: function() {
                                return null;
                            },
                            gameclass: function() {
                                return $scope.match.division.gameclass;
                            }
                        }
                    });                    
                }
            };
            $scope.setReferee = function() {
                var selected = $scope.match.referees;
                $modal.open({
                    templateUrl: 'views/getcustomermodal.html',
                    windowClass: 'huge-modal-window',
                    controller: 'GetCustomerCtrl',
                    resolve: {
                        options: function() {
                            return {
                                multiple: true,
                                itemFilter: function(item) {
                                    return item.type == 'user';
                                },
                                selected: selected
                             };
                        }
                    }
                }).result.then(function(customers) {
                    server.post('/api/teamsport/match/setreferee', null, {id: $scope.match.id, referee_id: _.pluck(customers, 'id')},
                        'Information saved', 'Failed to save information').then(function() {
                            $scope.contacts = null;
                        });
                });
            };

            $scope.buildMultiResultConfig = function() {
                $scope.multiResultConfig = {
                    getItems: function() {
                        return $scope.match.teams;
                    },
                    countSuffixList: $scope.match.division.competitionstep.gameclass.individual ? ['person', 'persons'] : ['team', 'teams'],
                    hideSearch: true,
                    columns: [
                        {field: 'team', title: $scope.match.division.competitionstep.gameclass.individual ? 'Name' : 'Team', format: 'image', text: function(team) { return team.name;}, src: teamsportutil.getImage, size: function() { return '50px'; } },
                        {field: 'result', title: 'Result', getValue: function(team) {
                            var r = _.findWhere($scope.match.result, {team_id: team.id});
                            if (r) {
                                return teamsportutil.formatResult(r);
                            }
                        }, compare: function(a, b) {
                            a = _.findWhere($scope.match.result, {team_id: a.id});
                            b = _.findWhere($scope.match.result, {team_id: b.id});
                            if (!a || !b) {
                                if (!a && !b) {
                                    return 0;
                                } else if (!a) {
                                    return -1;
                                } else if (!b) {
                                    return 1;
                                }
                            } else if (a.invalid_id && b.invalid_id) {
                                return a.invalid_id < b.invalid_id ? 1 : -1;
                            } else if (b.invalid_id) {
                                return 1;
                            } else if (a.invalid_id) {
                                return -1;
                            } else {
                                return a.result.localeCompare(b.result);
                            }
                        }
                    }
                    ]
                };
            };

            $scope.canSetShirtNumbers = function(team) {
                var member = teamsportutil.getCurrentMember();
                if (!member) {
                    return false;
                }

                if ($scope.match.finished) {
                    return false;
                }

                if ($scope.match.referees_id && $scope.match.referees_id.indexOf(member.id) != -1) {
                    return true;
                }

                if (team.group && team.group.responsible.indexOf(member.id) != -1) {
                    return true;
                }

                return $rootScope.hasPermission('Competition handling');
            };

            $scope.setShirtNumbers = function(team, bookings) {
                 $modal.open({
                    templateUrl: 'views/addmodal.html',
                    controller: 'SetShirtNumbersCtrl',
                    resolve: {
                        team: function() {
                            return team;
                        },
                        bookings: function() {
                            return bookings;
                        },
                        match: function() {
                            return $scope.match;
                        }
                    }
                });
            };

            $scope.teamCaptainRequired = function(team, bookings) {
                const leaderIds = team.group?.responsible || [];
                const leaderIsPresent = bookings.some(b => leaderIds.includes(b.user_id));

                return $scope.match?.team_captain && bookings.length > 1 && !leaderIsPresent;
            };

            $scope.setTeamCaptain = function(match, team, bookings) {
                $modal.open({
                    templateUrl: 'views/changemodal.html',
                    controller: 'TeamCaptainCtrl',
                    resolve: {
                        match: function() {
                            return match;
                        },
                        team: function() {
                            return team;
                        },
                        bookings: function() {
                            return bookings;
                        }
                    }
                });
            };

            $scope.getShirtNumber = function(team_id, user_id) {
                let match_number = _.findWhere($scope.match.shirt_numbers, {team: team_id, user: user_id});
                let group_number = $scope.match.teams?.find(t => t.id == team_id).group.shirt_numbers?.find(sn => sn.user_id == user_id);

                return match_number?.shirt || group_number?.shirt || null;
            };

            $scope.canReportResult = function() {
                return teamsportutil.canReportResult($scope.match);
            };

            $scope.canReportEvent = function() {
                return teamsportutil.canReportEvent($scope.match);
            };

            $scope.canLiveReport = function() {
                return teamsportutil.canLiveReport();
            };

            $scope.sendMailing = function() {
                var teams = $scope.match.teams;
                var receivers = [];
                Array.prototype.push.apply(receivers, $scope.match.referees);
                teams.forEach(function(team) {
                    if (team.group) {
                        Array.prototype.push.apply(receivers, team.group.users.map($rootScope.getMember));
                    }
                });
                receivers = _.uniq(receivers, 'id');
                var sendType = 'mail';
                var teamOne = $scope.match.teams.length > 0 ? $scope.match.teams[0].name : '';
                var teamTwo = $scope.match.teams.length > 1 ? $scope.match.teams[1].name : '';
                var message = $filter('translate')('Important match information between {0} - {1}, {2}').format(teamOne, teamTwo, formatter.format('datetime', $scope.match.activity.startTime));
                $scope.pubsub.publish('newmailingdata', {
                    isNewsOrAdvertising: false,
                    sendOption: sendType,
                    receivers: receivers,
                    subject: message,
                    message: message,
                    options: {'callCloseOnSuccess': false, 'modalMode': false, 'noRedirect': true}
                });
                $modal.open({
                    templateUrl: 'views/mailingnew.html',
                    windowClass: 'huge-modal-window',
                    controller: 'NewMailingCtrl'
                });
            };

            live.subscribe( {
                type: 'workoutbooking',
                scope: $scope,
                callback: function(wb) {
                    if ($scope.match && wb.workout) {
                        if ($scope.match.activity_id == wb.workout || _.findWhere($scope.match.team_activities, {id: wb.workout})) {
                            fetchMatch();
                        }
                    }
                }
            });

            live.subscribe( {
                type: 'teamsportevent',
                scope: $scope,
                callback: _.debounce(function(event) {
                    if ($scope.match && event.match_id == $scope.match.id) {
                        fetchEvents();
                        fetchTable();
                    }
                }, 300)
            });

            live.subscribe( {
                type: 'teamsportmatch',
                scope: $scope,
                callback: function(match) {
                    if ($scope.match && match.id == $scope.match.id) {
                        // Update result and referee
                        var props = ['finished', 'result', 'referees_id', 'teams', 'shirt_numbers'];
                        props.forEach(function(p) {
                            $scope.match[p] = match[p];
                        });
                        $scope.match.referees = teamsportutil.transformMatch(match).referees;
                        $scope.match.team_captains = match.team_captains;

                        $scope.contacts = null;

                        if ($scope.multiResultConfig.control) {
                            $scope.multiResultConfig.control.update();
                        }

                        fetchTable();
                    }
                }
            });

            live.subscribe( {
                type: 'workout',
                scope: $scope,
                callback: function(workout) {
                    if ($scope.match) {
                        if ($scope.match.activity_id == workout.id || _.findWhere($scope.match.team_activities, {id: workout.id})) {
                            fetchMatch();
                        }
                    }
                }
            });

            live.subscribe( {
                type: 'usergroup',
                scope: $scope,
                callback: function(group) {
                    if ($scope.match) {
                        if (_.find($scope.match.teams, function(t) { return t.group.id == group.id; })) {
                            fetchMatch();
                        }
                    }
                }
            });

            if ($routeParams.setresult) {
                var cancelMatchWatch = $scope.$watch('match', function() {
                    if (!$scope.match) { return; }
                    cancelMatchWatch();
                    $scope.setResult();
                });
            }

            $rootScope.requireLogin?.();
        }
    };
}]);

teamsportcommon.controller('TeamSportMatchCtrl', ['$scope', '$routeParams', function($scope, $routeParams) {
    $scope.config = {
        showSocialMediaShare: true,
        show_header: true,
        match_id: $routeParams.matchId
    };
}]);

teamsportcommon.controller('TeamSportEventAddCtrl', ['$scope', '$controller', '$filter', 'server', 'match', 'teamsportutil', 'util', function($scope, $controller, $filter, server, match, teamsportutil, util) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.titleSuffix = function() {
        return $filter('translate')('event_TEXT');
    };

    $scope.postUrl = '/api/teamsport/event/add';

    $scope.callCloseOnSuccess = false;

    $scope.matches = [match];
    var individual = match.division.competitionstep.gameclass.individual;

    function getPlayers() {
        var team = _.findWhere($scope.fields, {name: 'team_id'}).value;
        if (team) {
            var i = _.findIndex(match.teams, function(x) { return x.id == team.id; });
            var activity = match.team_activities[i];
            return _.pluck(activity.bookings, 'user');
        }
    }

    function getPlayerShirtNumberAndName(u) {
        var team = _.findWhere($scope.fields, {name: 'team_id'}).value;
        var a = _.findWhere(match.shirt_numbers, {team: team.id, user: u.id });
        let shirt = a && a.shirt;
        if (!shirt) {
            let shirtUser = team.group?.shirt_numbers?.find(user => user.user_id == u.id);
            shirt = shirtUser && shirtUser.shirt;
        }        
        return (shirt ? shirt + ' - ' : '') + u.name;
    }

    function fetchEventTypes() {
        server.get('/api/teamsport/eventtype/get').then(function(data) {
            $scope.eventtypes = match.division.competitionstep.gameclass.competition.teamsport.eventtypes.map(function(id) {
                return _.findWhere(data, {id: id});
            });
        });
    }

    function fetchInvalidTypes() {
        server.get('/api/teamsport/resultinvalid/get').then(function(res) {
            $scope.invalidtypes = res;
            $scope.invalidtypes.unshift({id: 0, name: 'Valid result'});
        });
    }

    function teamChanged() {
        _.findWhere($scope.fields, {name: 'user_id'}).value = null;
    }

    $scope.setInitialValues = function() {
        _.findWhere($scope.fields, {name: 'match_id'}).value = match;
        _.findWhere($scope.fields, {name: 'update_result'}).value = true;
        if ($scope.eventtypes.length == 1) {
            _.findWhere($scope.fields, {name: 'eventtype_id'}).value = $scope.eventtypes[0];
        }
    };

    function showUpdateResult() {
        var et = _.findWhere($scope.fields, {name: 'eventtype_id'}).value;
        return et && et.points;
    }

    function showPlayer() {
        var et = _.findWhere($scope.fields, {name: 'eventtype_id'}).value;
        return et && et.player && !individual;
    }

    function showTeam() {
        var et = _.findWhere($scope.fields, {name: 'eventtype_id'}).value;
        return et && (et.team || individual);
    }

    function showSetResult() {
        var et = _.findWhere($scope.fields, {name: 'eventtype_id'}).value;
        return et && et.setresult;
    }

    function resultIsValid() {
        if (!showSetResult()) {
            return true;
        }

        var result = _.findWhere($scope.fields, {name: 'result'});
        return !result.visible() || teamsportutil.isResultValid(result.value, match.result_type);
    }

    var periods = match.division.competitionstep.gameclass.competition.teamsport.timeperiods ? match.division.competitionstep.gameclass.competition.teamsport.timeperiods.split(',').map(function(x) { return {name: x, id: x}; }) : [];

    $scope.canSubmit = function() {
        return (showPlayer() && _.findWhere($scope.fields, {name: 'user_id'}).value) || (showTeam() && _.findWhere($scope.fields, {name: 'team_id'}).value) && resultIsValid();
    };

    var gs = $scope.getSubmitItem;
    $scope.getSubmitItem = function() {
        var item = gs();
        if (item.invalid_id == 0) {
            item.invalid_id = null;
        }
        // matchtime in HH.MM.SS into seconds
        if (item.matchtime) {
            var parts = item.matchtime.split('.');
            if (parts.length == 3) {
                item.matchtime = Number(parts[0]) * 3600 + Number(parts[1]) * 60 + Number(parts[2]);
            }
        }

        return item;
    };

    var resultInfo = match.unit || teamsportutil.getResultTypeHint(match.result_type);

    $scope.fields = [
        {name: 'match_id', title: 'MATCH', type: 'select', required: true, readonly: true, useId: true, options: function() {return $scope.matches; }, getName: function(match) { return match && teamsportutil.getMatchName(match); } },
        {name: 'eventtype_id', title: 'Event type', type: 'select', required: true, options: function() { return $scope.eventtypes; }, useId: true },
        {name: 'timeperiod', title: 'Period', type: 'select', required: false, visible: function() { return periods.length; }, options: function() { return periods; }, orderPredicate: 'none', useId: true },
        {name: 'matchtime', title: 'Match time', type: 'text', required: false },
        {name: 'team_id', title:  individual ? 'Person' : 'Team', type: 'select', required: false, options: function() { return match.teams; }, useId: true, getName: function(team) { return team.name; }, change: teamChanged, visible: showTeam },
        {name: 'user_id', title: 'Player', type: 'select', required: false, options: getPlayers, useId: true, visible: showPlayer, getName: getPlayerShirtNumberAndName },
        {name: 'invalid_id', title: 'Result', type: 'select', options: function() { return $scope.invalidtypes; }, required: false, visible: showSetResult, useId: true },
        {name: 'result', title: '', type: 'infoText', required: false, visible: function() { var invalid_id = _.findWhere($scope.fields, {name: 'invalid_id'}).value; return invalid_id && invalid_id.id == 0 && showSetResult(); }, info: resultInfo },
        {name: 'comment', title: 'Comment', type: 'textarea', required: false },
        {name: 'update_result', title: 'Update result', type: 'checkbox', required: false, visible: showUpdateResult }
    ];

    fetchEventTypes();
    fetchInvalidTypes();

    util.waitFor($scope, 'eventtypes').then($scope.setInitialValues);
}]);

teamsportcommon.controller('TeamSportEventChangeCtrl', ['$scope', '$controller', 'confirm', 'server', 'util', 'match', 'teamsportevent', function($scope, $controller, confirm, server, util, match, teamsportevent) {
    $controller('TeamSportEventAddCtrl', {$scope: $scope, match: match});
    $controller('ChangeCtrl', {$scope: $scope});

    $scope.item = teamsportevent;

    $scope.postUrl = '/api/teamsport/event/change';
    $scope.callCloseOnSuccess = true;

    $scope.remove = function() {
        confirm.show('Are you sure you want to remove the event?', {ladda: true}).then(function(resolve) {
            server.post('/api/teamsport/event/remove', null, {id: teamsportevent.id}).then(function() {
                resolve();
                $scope.$close();
            });
        });
    };

    util.waitFor($scope, 'eventtypes').then(function() {
        $scope.setValues($scope.item);
    });
}]);
